export default __webpack_public_path__ + "static/media/spinner.60d9adc4.gif";